import * as React from 'react'
// context
import { TasksListBLContext } from 'containers/StrategyActions/components/TasksList/layers/BL'
import { StrategyActionsBLContext } from 'containers/StrategyActions/layers/BL'
// hooks
import { useCurrentUser } from 'hooks'
// view components
import Plan from './components/Plan/index'
import Task from './components/Task'
// types
import { IPosition, IUser } from 'types/graphql'
// views
import { CollapseIcon, CollapseWrapper, Paper, TasksWrapper, Wrapper } from './views'
// utils
import moment from 'moment'
import { get, isEmpty } from 'lodash'
import { isCurrentUser } from 'utils'

const TasksList: React.FC = () => {
  const [isCollapsed, setCollapsed] = React.useState(false)

  const { isGroupedByPlan } = React.useContext(StrategyActionsBLContext)
  const { onTaskClick, plan, closestPlanTask, tasks } = React.useContext(TasksListBLContext)

  const user = useCurrentUser()

  // constants
  const isReviewExist = !isEmpty(closestPlanTask)
  const reviewers: IUser[] | IPosition[] = get(closestPlanTask, 'assignedPersons')

  const shouldShowPlan = isGroupedByPlan && (!isEmpty(tasks) || !!closestPlanTask)

  const canComplete =
    isReviewExist &&
    reviewers.some(({ id }) => isCurrentUser(id, user)) &&
    moment().isSameOrAfter(closestPlanTask.startPeriod, 'day')

  // methods
  const handleCollapse = (event: React.MouseEvent) => {
    event.stopPropagation()
    setCollapsed(!isCollapsed)
  }

  const handleOnTaskClick = () => onTaskClick(plan)

  if (!closestPlanTask && isEmpty(tasks)) {
    return null
  }

  return (
    <Wrapper>
      {shouldShowPlan && (
        <Paper isTaskExist={canComplete} onClick={handleOnTaskClick}>
          <CollapseWrapper>
            {!!tasks.length && <CollapseIcon onClick={handleCollapse} isCollapsed={isCollapsed} />}
            <Plan />
          </CollapseWrapper>
        </Paper>
      )}

      <TasksWrapper $isGroupedByPlan={isGroupedByPlan} $isCollapsed={isCollapsed}>
        {!isCollapsed && tasks.map((task, idx) => <Task key={idx} task={task} />)}
      </TasksWrapper>
    </Wrapper>
  )
}

export default TasksList
